export default {
    "entityName": "country",
    "title": "Country",
    "id": ['code'],
    "pagination": {
        "rowsPerPage": 10,
        "page": 1,
        "sortBy": "emn_code",
        "descending": false
    },
    "fields": [
       
        {
            "value": "code",
            "text": "Code",
            title: "code",
            readonly: item => { return item._exists},
            // subtitle: item => `${item.name}`,
            "type": "text",
            "table": {
                "sortable": true,
                filter: true
            },
            validators: ['required'],
        },
        {
            "value": "name",
            "text": "Name",
            title: "name",
            // subtitle: item => `${item.name}`,
            "type": "text",
            "table": {
                "sortable": true,
                filter: true
            },
            validators: ['required'],
        },
        {
            "value": "emn_code",
            "text": "EMN Code",
            title: "emn_code",
            // subtitle: item => `${item.name}`,
            "type": "text",
            "table": {
                "sortable": true,
                filter: true
            },
            validators: ['required'],
        },
    ],
    "actions": [
        "upsert",
        "remove",
        "audit_trail"
    ]
}